import { getTheme, heStudymeisterTokens } from "@infinitaslearning/pixel-design-system";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { initAnalyticstracker } from "analytics";
import { basePath } from "constants/env-constants";
import { useProfile } from "hooks/useProfile";
import type React from "react";
import { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider as StyledComponentsThemeProvider } from "styled-components/macro";
import { GlobalAppStyles } from "styles/GlobalApp.styled";

import { ToastNotification } from "components/ToastNotification";
import { WebObservabilityProvider } from "providers";

import AppRouter from "./AppRouter";
import { theme as styledComponentsTheme } from "./themes";

const App: React.FC = () => {
  const { userInfo } = useProfile();

  useEffect(() => {
    initAnalyticstracker()?.listen({ isInternalLink: basePath });
  }, []);

  return (
    <MuiThemeProvider theme={getTheme(heStudymeisterTokens)}>
      <StyledComponentsThemeProvider theme={styledComponentsTheme}>
        <Suspense fallback={<div />}>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <WebObservabilityProvider user={userInfo} />
            <GlobalAppStyles />
            <AppRouter />
            <ToastNotification />
          </BrowserRouter>
        </Suspense>
      </StyledComponentsThemeProvider>
    </MuiThemeProvider>
  );
};

export default App;
